import {ListSort, _Objects} from './main';

export class SearchPage {
    constructor(selector) {
        let _this = this;

        _this.$container = $(selector);
        _this.$list = _this.$container.find('.js-search-results-list');
        _this.$listItem = null;
        _this.$cardsBox = _this.$container.find('.js-search-results-cards');
        _this.$card = null;
        _this.$filter = _this.$container.find('.js-search-filter');
        _this.mapData = _Objects.MapData;

        _this.$templates = _this.$container.find('.search__templates');
        _this.$itemTmpl = _this.$templates.find('.js-search-result-item');

        _this.isActive = false;
        _this.isLoading = false;

        _this._container = this;
        _this.$container.data('_searchPage', _this._container);

        _this.init();
    }

    init() {
        let _this = this;

        _this.initEvents();
        _this.initFiltering({
            valueNames: [{ attr: 'data-filterid', name: 'search-result' }],
            listClass: 'js-search-results-list'
        });
    }
    initEvents() {
        let _this = this;
        let $container = _this.$container;
        let $filter = _this.$filter;

        $container.on('sPage.show', (e) => {
            _this.show();
        });
        $container.on('sPage.hide', (e) => {
            _this.hide();
        });
        $container.on('sPage.itemsSet', (e, $listItems) => {
            _this.reindexFiltering();
        });
        $filter.on('changed', (e, value) => {
            _this.filterItems(value !== 'search-all' ? value : '', 'search-result');
        });
    }
    initFiltering(params = {}) {
        let _this = this;
        let $container = _this.$container;

        _this.$list.data('listSortParams', params);
        _this._listSort = new ListSort(_this.$list);

        let _listSortInstance = _this._listSort._listSort;
        _listSortInstance.on('filterComplete', (e) => {
            $container.trigger('filtered', [_listSortInstance.matchingItems.length, e.type]);
        });
        _listSortInstance.on('searchComplete', (e) => {
            $container.trigger('filtered', [_listSortInstance.matchingItems.length, e.type]);
        });
    }
    reindexFiltering() {
        let _this = this;

        _this._listSort.reIndex();
    }

    searchItems(searhString, searchCols) {
        let _this = this;
        _this._listSort.searchValues(searhString, searchCols);
    }
    filterItems(filterString, filterName) {
        let _this = this;
        _this._listSort.filterValues(filterString, filterName);
    }

    setResults(data = {}) {
        let _this = this;

        if (!Object.keys(data).length) return false;

        _this.setListItems(data.items);
        _this.setCards(data.cards);
    }
    setListItems(data = {}) {
        let _this = this;
        let $container = _this.$container;
        _this.$list.empty();

        $container.removeClass('_nodata');
        if (!data || !data.length) {
            $container.addClass('_nodata');
            return false;
        }

        data.forEach((elem) => {
            _this.setListItem(elem);
        });
        _this.$listItem = $container.find('.js-search-result');
        _this.initItemsClicking();
        $container.trigger('sPage.itemsSet', [_this.$listItem]);
    }
    setListItem({id, name, parentName, financing, type}) {
        const _this = this;
        const $itemCard = _this.$itemTmpl.clone();

        $itemCard.find('.js-search-result')
            .attr('data-filterid', `search-${type}`)
            .data('filterid', `search-${type}`)
            .data('region-id', `${type}-${parseInt(id, 10)}`)
            .attr('data-region-id', `${type}-${parseInt(id, 10)}`);

        $itemCard.find('.js-search-result-title').text(name);
        if (parentName) {
            $itemCard.find('.js-search-result-desc').text(parentName);
        }
        const finance = (financing) ? financing / 1000000 : 0;
        const financeStr = ('' + finance.toFixed(2)).replace(/\./, ',');
        $itemCard.find('.js-search-result-currency').text(financeStr);

        $itemCard.removeClass('_template');

        _this.$list.append($itemCard);
    }
    setCards(data = {}) {
        let _this = this;
        let $container = _this.$container;
        let $cardsBox = _this.$cardsBox;
        $cardsBox.empty();
        data.forEach((card) => {
            const $card = $(card);
            const $cardCopy = $card.clone(true);
            $cardsBox.append($cardCopy);
        });

        _this.$card = $cardsBox.find('.js-card');
        $container.trigger('sPage.cardSet', [_this.$card]);
    }

    initItemsClicking() {
        const _this = this;
        const regionMap = _Objects.RegionMap;
        const $items = _this.$listItem;

        $items.on('click', function () {
            const $item = $(this);
            const regionId = $item.data('region-id');
            const [structureName, structureId] = regionId.split('-');

            _Objects.Search.hide();
            _Objects.RegionMap.ObjectPage.hide();
            _Objects.RegionMap.isFromSearch = true;
            let timeout = 0;
            if ($('html').data('page') !== 'build-progress') {
              _Objects.Page.setPage('build-progress');
              timeout = 750;
            }

            regionMap.dataUpdatingPromise.then(() => {
              let regionLevel = 0;
              if (structureName === 'fo') {
                regionLevel = 2;
              } else if (structureName === 'subj') {
                regionLevel = 3;
              } else {
                regionLevel = 4;
              }
              regionMap.setRegionLevel(regionLevel);
              const $currRegion = regionMap.$regions.filter(`[data-region-id="${regionId}"]`).addClass('_nominated');
              if (structureName === 'obj') {
                regionMap.setSelectedObject(regionId);
                setTimeout(() => {
                  regionMap.setRightPanel(regionId);
                }, timeout);
              } else {
                regionMap.setSelectedRegion($currRegion, timeout);
              }
            });

        });
    }

    show() {
        let _this = this;
        let $container = _this.$container;

        if (_this.isActive) return false;
        _this.isActive = true;
        $container.addClass('_active');
        $('html').addClass('search-page-active');
    }
    hide() {
        let _this = this;
        let $container = _this.$container;

        if (!_this.isActive) return false;
        _this.isActive = false;
        $container.removeClass('_active');
        $('html').removeClass('search-page-active');
    }

    setLoading(isLoading = false) {
        let _this = this;

        _this.isLoading = isLoading;
        _this.$container.toggleClass('_loading', isLoading);
    }
}

export class SearchInput {
    constructor(selector) {
        let _this = this;
        _this.$container = $(selector);
        _this.$inputBox = _this.$container.closest('.js-search-box');

        _this._container = this;
        _this.$container.data('_searchInput', _this._container);

        _this.init();
    }

    init() {
        let _this = this;

        _this.initEvents();
    }
    initEvents() {
        let _this = this;
        let $input = _this.$container;
        let $inputBox = _this.$inputBox;

        $input.on('search', () => {

        });
        $inputBox.on('click', (e) => {
            $input.focus();
        })
    }

    getValue() {
        let _this = this;
        let $input = _this.$container;

        return $input.val().trim() || '';
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/src/search.js